import { render } from "./ChatIndexRail.vue?vue&type=template&id=6c5a8cdd&scoped=true"
import script from "./ChatIndexRail.vue?vue&type=script&lang=js"
export * from "./ChatIndexRail.vue?vue&type=script&lang=js"

import "./ChatIndexRail.vue?vue&type=style&index=0&id=6c5a8cdd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5a8cdd"]])

export default __exports__